// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"dee29cbb8aecf940","1060":"ed3c31d9e320d660","1221":"9837947529296d6a","3602":"7396a65111f5a022","4937":"a2fb1d034f6c30bf"}[chunkId] + ".css";
};